import { motion } from "framer-motion";

export default function AboutSection() {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative overflow-hidden gold-glow">
              <img
                src="https://customer-assets.emergentagent.com/job_luxury-wellness-tr/artifacts/ql1rpdyo_afd8ac3c621e7a5a912bac9e6b420c28.jpg"
                alt="Purevia Güzellik Ekibi"
                className="w-full h-[350px] md:h-[500px] object-cover object-top"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 h-1 gold-bg" />
            </div>
            {/* Floating stat */}
            <div className="absolute -bottom-6 -right-4 md:right-8 bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.08)] border border-[#EBEBEB]">
              <div className="text-3xl font-bold tracking-tighter gold-text">5+</div>
              <div className="text-xs font-semibold uppercase tracking-widest text-gray-600 mt-1">Yıllık Deneyim</div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-4">
              Hakkımızda
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-6">
              Güzelliğe Adanmış Bir Tutku
            </h2>
            <div className="space-y-4 text-base leading-relaxed text-black/80">
              <p>
                Purevia Güzellik olarak Bursa'da güzellik ve bakım alanında premium hizmet sunmayı misyon edindik. Uzman kadromuz ve son teknoloji cihazlarımızla her müşterimize özel bakım protokolleri uyguluyoruz.
              </p>
              <p>
                Hijyen, kalite ve müşteri memnuniyeti bizim için sadece bir vaat değil, yaşam biçimimizdir. Her detayı özenle planlıyor, her hizmeti en yüksek standartlarda sunuyoruz.
              </p>
              <p>
                Görükle ve Bursa genelinde binlerce mutlu danışanımızla büyümeye devam ediyoruz. Sizin güzelliğiniz, bizim önceliğimiz.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-[#EBEBEB]">
              <div>
                <div className="text-2xl font-bold tracking-tighter gold-text">10K+</div>
                <div className="text-xs text-gray-600 mt-1">Mutlu Danışan</div>
              </div>
              <div>
                <div className="text-2xl font-bold tracking-tighter gold-text">6</div>
                <div className="text-xs text-gray-600 mt-1">Hizmet Alanı</div>
              </div>
              <div>
                <div className="text-2xl font-bold tracking-tighter gold-text">%100</div>
                <div className="text-xs text-gray-600 mt-1">Memnuniyet</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
